/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState, AUTH_KEY } from './auth.reducer';

const state = createFeatureSelector<AuthState>(AUTH_KEY);
export const getAuthState = createSelector(state, (state: AuthState) => state);
